// 存物完成
<template>
  <div class="mailSaveFinish back-index">
    <!-- 流程 -->
    <userSaveFlow v-if="oType === 'userSave'"/>
    <userFastSaveFlow v-if="oType === 'userFastSave'"/>

    <div class="container" v-loading="isLoading">

      <span class="status" v-if="box.status" :class="[box.error ? 'success' : 'fail']"></span>

      <p class="info" v-if="box.status && !box.error" v-text="box.message"></p>
      
      <!-- <p class="info" v-if="box.status && box.error" v-text="box.number === '' ? '请投递信件' : '请将信件投入到' + box.number + '号箱格里'"></p> -->
      <p class="info" v-if="box.status && box.error">投递完成</p>
      
    </div>

    <p class="save-again" @click="saveAgain">再存一个</p>

    <!-- 倒计时60秒 -->
    <countDown :time="60" v-if="!isLoading"></countDown>

    <!-- 底部按钮 -->
    <btnCancel></btnCancel>
  </div>
</template>

<script>
// 组件
import countDown from '../common/countDown'
import btnCancel from '../common/btnCancel'
import userSaveFlow from '../userSave/userSaveFlow'
import userFastSaveFlow from '../userFastSave/userFastSaveFlow'

// js
import {
  showToast,
  showLoading,
  hideLoading,
  sendPackageNo,
  clearCountDown,
} from '../../../../static/mailBox/js/request.js'
import { storage } from '../../../../static/js/utils/utility'

export default {
  name: 'saveFinish',
  components: {
    btnCancel,
    countDown,
    userSaveFlow,
    userFastSaveFlow
  },
  data () {
    return {
      type: '',
      oType: '',
      box: {
        number: '',
        error: false,
        status: false,
      },
      isLoading: false,
    }
  },
  created () {
    console.log('用户的身份：', this.$store.state.mail_type)
    console.log('用户选择的业务类型：', this.$store.state.mail_oType)
    console.warn('到存件完成页面时候的订单数据：', this.$store.state.mail_deliver)
    // this.deliver()
    this.box = this.$store.state.mail_box
    this.type = this.$store.state.mail_type
    this.oType = this.$store.state.mail_oType
    if (this.oType === 'userSave') {
      // this.$store.state.mail_index  = 4
      this.$store.commit('mail_index', 4)
    } else if (this.oType === 'userFastSave') {
      // this.$store.state.mail_index  = 3
      this.$store.commit('mail_index', 3)
    }
  },
  mounted () {

  },
  destroyed() {
    console.warn('destroyed')
    clearCountDown()
  },

  methods: {
    // 提交订单数据，返回取件人箱格号，提示存件人把快递存入对应箱格
    deliver: async function () {
      let vm = this
      vm.isLoading = true
      let device_no_id = storage.localGetItem('device_no_id')
      let data = {...vm.$store.state.mail_deliver, device_no_id}
      console.log('data', data)
      let res = await sendPackageNo(data)
      if (res.meta.code === 200) {
        vm.box.status = true
        vm.box.error = true
        if (res.data.box_number) {
          vm.box.number = res.data.box_number
        } else {
          vm.box.number = ''
        }
      } else {
        vm.box.error = false
        vm.box.status = true
        vm.box.message = res.meta.message
        showToast(res.meta.message)
      }
      vm.isLoading = false
    },

    // 再存一个
    saveAgain: function () {
      let vm = this
      if (vm.oType === 'userSave') {
        clearCountDown()
        vm.$router.push({
          // 你要跳转的地址
          path: '/mailBox/userSave/selectConsignee',
        })
      }
      if (vm.oType === 'userFastSave') {
        clearCountDown()
        vm.$router.push({
          // 你要跳转的地址
          path: '/mailBox/userSave/scanExpressCode',
        })
      }
    }
  },
  
}
</script>

<style lang="less">
.mailSaveFinish {
  .container {
    min-height: 3rem;
    position: relative;
    .el-loading-mask {
      background-color: transparent;
    }
  }
}
</style>

<style lang="less" scoped>
.mailSaveFinish {
  width: 100%;
  text-align: center;
  .container {
    .status {
      display: block;
      width: 2rem;
      height: 2rem;
      margin: 0.8rem auto 0;
    }
    .status.success {
      background: url(../../../../static/mailBox/images/icon/success.png) center no-repeat;
      background-size: 100%;
    }
    .status.fail {
      background: url(../../../../static/mailBox/images/icon/fail.png) center no-repeat;
      background-size: 100%;
    }
    .info, .des {
      font-size: 0.45rem;
      line-height: 0.85rem;
    }
    .info {
      margin-top: 0.45rem;
    }
  }
  .hint {
    font-size: 15px;
    color: #ff0000;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .save-again {
    display: block;
    width: 4.56rem;
    margin: 0.5rem auto 0;
    height: 1.82rem;
    line-height: 1.82rem;
    text-align: center;
    border-radius: 0.1rem;
    font-size: 0.7rem;
    font-weight: bold;
    padding: 0;
    background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
    background: linear-gradient(to top,#076abf, #4cacff);
    box-shadow: #2c4b64 0px 0px 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/common/saveFinish.vue